import router from '../../router.js'

// initial state
const state = {
  init: false,
  show: false,
  ready: false
}

// getters
const getters = {
  show: state => state.show
}
/*
this.debouncedFx = _.debounce(function(value) {
  self.init_tendina = value;
  self.stato_tendina = value;
  setTimeout(function() {
    self.tendina_ready = true;
  }, 0);
}, 500);
EventBus.$on("stato_tendina", valore => {
  //IMPLEMENTARE QUI DEBOUNCE !!!!
  if (valore === true) {
    self.debouncedFx(valore);
  } else {
    //this.tendina_ready = valore
    this.stato_tendina = valore;
    //distruggo la tendina solo dopo averla chiusa e l' animazione è finita.
    setTimeout(function() {
      self.init_tendina = valore;
    }, 800);
  }
});
*/

// actions
const actions = {
  // manca debounce qui dentro
  openCurtain({ commit, state }, source) {
    // eslint-disable-next-line no-undef
    this.debouncedFx = _.debounce(function (value) {
      commit('setInitState', value)
      commit('setShowState', value)
      setTimeout(function () {
        commit('setReadyState', value)
      }, 0)
    }, 200)
    this.debouncedFx(true)
  },
  //BRENNO: HO AGGIUNTO IL PAYLOAD PRESERVE_URL PERCHE'
  //QUANDO PRIMA QUANDO APP NON AVEVA ID E INTENT RICHIAMAVA CLOSECURTAIN
  //CHE PER DEFAULT AZZERAVA L'URL TOGLIENDO LE PARAMS MA CIO' NON VA BENE
  //SE PER ESEMPIO IN QUEL MOMENTO HO COME PARAMS '?CHECKOUT=numeroordine'
  closeCurtain({ commit, state }, preserveURL) {
    // rimuovo la stringa per apertura tendina dall' url
    if (preserveURL === undefined) router.replace(router.currentRoute.path)
    commit('setShowState', false)
    // distruggo la tendina solo dopo averla chiusa e l' animazione è finita.
    setTimeout(function () {
      commit('setInitState', false)
    }, 800)

  }
}

// mutations
const mutations = {
  setInitState(state, bool) {
    state.init = bool
  },
  setShowState(state, bool) {
    state.show = bool
  },
  setReadyState(state, bool) {
    state.ready = bool
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
